import { SelectInput } from "@src/components/ui-components/Selectors/SelectInput/SelectInput";
import { IRawDataType } from "@src/data-hooks/data-types/dataTypes.types";
import { translate } from "@src/libs/i18next/translations.util";
import { CustomFieldDataOptions } from "@src/to-be-removed/LocalData/Property/Collections/PropertyCustomFieldData";
import { getStringArray } from "@src/utils/arrayUtilities";
import { useEffect, useState } from "react";
import { CustomFieldDataType } from "../../CustomFieldDataType";
import { DataEditorContext } from "../CustomFieldDataTypeHelper";

type Props = {
  data: any | undefined;
  options: CustomFieldDataOptions;
  context: DataEditorContext;
  setRawData: (data: string | string[] | undefined) => void;
};
export const CustomDataTypeEditor = ({ data, options, context, setRawData }: Props) => {
  const [dataType, setDataType] = useState<IRawDataType | undefined>(undefined);

  const dataOptions =
    dataType && options.customDataTypeID
      ? Object.entries(dataType.options).sort(([, a], [, b]) => translate(a.name).localeCompare(translate(b.name)))
      : [];

  useEffect(() => {
    if (!options.customDataTypeID) {
      setDataType(undefined);
      return;
    }
    const existingType = CustomFieldDataType.CUSTOM_DATA_TYPE.getDataType(options.customDataTypeID, context);
    if (existingType) {
      setDataType(existingType);
      return;
    }
    CustomFieldDataType.CUSTOM_DATA_TYPE.loadDataType(options.customDataTypeID, context).then((data) => setDataType(data));
  }, [context, options]);

  return (
    <SelectInput
      width="100%"
      isMulti={options.isMulti ?? false}
      options={dataOptions.map(([key, option]) => ({ value: key, label: translate(option.name) }))}
      value={options.isMulti ? getStringArray(data) : data}
      onChange={(selected) => {
        if (options.isMulti && Array.isArray(selected)) {
          setRawData([...selected]);
        } else {
          setRawData(selected ? "" + selected : undefined);
        }
      }}
    />
  );
};
